export const API_KEY = {
    AMAP_KEY: 'b54b465811a8316d58d0c1ff9db92065',
    FEISHU_WEBHOOK_KEY: 'e0143bf7-fdc4-4e47-9d2e-5901a1c63426'
}